import { AlertService } from './../../service/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissoesService } from './../../service/permissoes.service';
import { Permissoes } from './../../model/permissao.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-atualizar-permissao',
  templateUrl: './atualizar-permissao.component.html',
  styleUrls: ['./atualizar-permissao.component.css']
})
export class AtualizarPermissaoComponent implements OnInit {

  permissao: Permissoes = {
    vc_nome: '',
    vc_descricao: ''
  }

  constructor(private service: PermissoesService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.permissao.sr_id = this.activatedRoute.snapshot.paramMap.get('sr_id')!;
    this.listarPorId();
  }

  listarPorId(): void {
    this.service.listarPorIdService(this.permissao.sr_id).subscribe(resp => {
      this.permissao = resp
    })
  }

  atualizar(): void {
    this.service.atualizarService(this.permissao).subscribe(resp => {
      this.alertService.success()
      this.router.navigate(['configuracao/permissoes'])
    }, error => {
      this.alertService.error(error);
    })
  }

  

  cancel(){
    this.router.navigate(['configuracao/permissoes']);
  }

}
